const maskPhoneNumber = (phoneNumber: string) => {
  return phoneNumber?.replace(/(\d{4})\d{3}(\d{4})/, "$2***$1")
}

export default maskPhoneNumber